//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
import "../Diagramming/Diagramming.SheetElementBuilder.js";
import "../Diagramming/Diagramming.Geometry.SelectBaseGeometryList.js";
import "../no/ugmath.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Geometries",0,"Diagramming.Geometry.SelectBaseGeometryList",0],[0,"SelectionMode",1,0]],[[[],"GetSeedPoint",{R_:{point:''}},0,0],[["point"],"SetSeedPoint",{},1,0],[["isFillByPoint"],"SetIsFillByPoint",{},1,0]],[]];
SPLM.Diagramming.FillBuilder = class extends SPLM.Diagramming.SheetElementBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Diagramming.FillBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Diagramming.FillBuilder.SelectionType = Object.freeze({
    "PointInRegion" : "PointInRegion", "BoundaryGeometries" : "BoundaryGeometries"});

export default SPLM;